// extracted by mini-css-extract-plugin
module.exports = {"pb":"diff-styles_pb__ytwZD","pl":"diff-styles_pl__1qAX0"};